import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/shared/accordion';
import { QuestionMarkDoodle } from './QuestionMarkDoodle';

const FAQS = [
  {
    q: 'Is Nestra free?',
    a: 'Yes, free to get started. Sign up and create your link!',
  },
  {
    q: 'Who is Nestra for?',
    a: 'Any creative. Musicians, filmmakers, photographers, illustrators, writers. If you make things, Nestra is for you.',
  },
  {
    q: 'What can I show on my page?',
    a: 'Releases, upcoming drops, events, screenings, pop-ups, and links to all your platforms. Everything in one place.',
  },
  {
    q: 'Can I use my own domain?',
    a: 'Custom domains are available on paid plans. On the free plan you get a nestra.co/yourname URL.',
  },
  {
    q: 'Do I need to know how to code?',
    a: 'Not at all. Your page is live in minutes with no technical knowledge required.',
  },
];

export function LandingFAQ() {
  return (
    <section className="landing-faq" id="faq">
      <div className="landing-wide landing-faq__inner">
        <div className="landing-faq__intro">
          <h2 className="landing-faq__title">
            Let&apos;s answer your questions
          </h2>
          <QuestionMarkDoodle />
        </div>
        <Accordion type="single" collapsible className="landing-faq__list">
          {FAQS.map(({ q, a }, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger>{q}</AccordionTrigger>
              <AccordionContent>{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
